<template>
  <pt-detection-package-detail class="pt-detection-package-detail__withData"></pt-detection-package-detail>
</template>

<script>
import PtDetectionPackageDetail from './index'
export default {
  name: 'pt-detection-package-detail__withData',
  components: {
    'pt-detection-package-detail': PtDetectionPackageDetail
  }
}
</script>
